// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"e8924c52","171":"0feae70a","429":"645f5c04","923":"5fb6c0ff"}[chunkId] + ".chunk.js";
};